export default __webpack_public_path__ + "img/Image-404@2x.3ee5f52e6facacf9a838cb607cc119ba.png";